/* BROHN SMITH: homepage slide deck fix.
   The split category slide is rendered twice: one desktop version and two
   mobile versions, with CSS hiding whichever does not apply. Swiper still
   counts the hidden slides (at zero height) when it works out where the deck
   ends, so on desktop it stopped two slides short: the Bokor film and the
   footer could never be reached, and on mobile the footer was cut off.
   Removing the hidden slides from the DOM before Swiper initialises (this
   file is deferred ahead of theme.js) gives Swiper the real slide count. */
(function () {
  'use strict';
  var deck = document.querySelector('[data-homepage-swiper]');
  if (!deck) return;
  var mobile = window.matchMedia('(max-width: 768px)');
  var kill = mobile.matches ? '.split-slide-desktop' : '.split-slide-mobile';
  Array.prototype.slice.call(deck.querySelectorAll(kill)).forEach(function (s) {
    s.parentNode.removeChild(s);
  });
  /* Crossing the breakpoint (rotating a tablet, resizing a window) needs the
     other set of slides back, so rebuild the page once when that happens. */
  var wasMobile = mobile.matches;
  window.addEventListener('resize', function () {
    if (mobile.matches !== wasMobile) window.location.reload();
  });
})();
